import {memo} from 'react';

import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {brandName, isJustEat} from '~/shared/config';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import orangeSmLogoUrl from '~/assets/images/orange-sm-logo.svg';
import orangeLgLogoUrl from '~/assets/images/tenBis-logo.svg';
import orangeMdLogoUrl from '~/assets/images/tenBis-logo-md.svg';
import jeOrangeLgLogoUrl from '~/assets/images/je-orange-lg-logo.svg';
import jeOrangeMobileLogoUrl from '~/assets/images/just-eat-mobile-logo.svg';
import govOrangeLgLogoUrl from '~/assets/images/gov-orange-lg-logo.svg';
import {selectIsGovCompanyUser} from '~/shared/store/selectors';
import {useIsMinLargeMobile, useIsMinLargeTablet} from '~/shared/hooks/deviceInfo';
import {Link} from '~/shared/router';
import {defaultStartPage} from '~/shared/services/navigation';
import {media} from '~/shared/theme/media';

const SharedLogoCss = styled(ImageWithAlt).attrs({
  alt: brandName,
})`
  cursor: pointer;
`;

const SmOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeSmLogoUrl,
})``;

const MdOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeMdLogoUrl,
})``;

const LgOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeLgLogoUrl,
})``;

const JeOrangeLogo = styled(SharedLogoCss).attrs({
  src: jeOrangeLgLogoUrl,
})`
  width: 100px;
  height: 16px;
  ${media.minLargeMobile`
    width: 146px;
    height: 24px;
  `}
`;

const JeOrangeMobileLogo = styled(SharedLogoCss).attrs({
  src: jeOrangeMobileLogoUrl,
})`
  width: 32px;
  height: 32px;
`;

const GovLgOrangeLogo = styled(SharedLogoCss).attrs({
  src: govOrangeLgLogoUrl,
})``;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const Logo = ({isHardLogoClick}: {isHardLogoClick: boolean}) => {
  const startPageLink = defaultStartPage();

  const isMinLargeMobile = useIsMinLargeMobile();
  const isMinLargeTablet = useIsMinLargeTablet();

  const isGovCompanyUser = useSelector(selectIsGovCompanyUser);

  if (isJustEat) {
    const LogoComponent = !isMinLargeMobile ? JeOrangeMobileLogo : JeOrangeLogo;

    return (
      <StyledLink data-id="main-header-logo" href={startPageLink} hard={isHardLogoClick}>
        <LogoComponent alt={brandName} />
      </StyledLink>
    );
  }

  return (
    <StyledLink data-id="main-header-logo" href={startPageLink} hard={isHardLogoClick}>
      {isGovCompanyUser && isMinLargeTablet ? (<GovLgOrangeLogo />) : (
        <>
          {!isMinLargeMobile && !isMinLargeTablet && <SmOrangeLogo />}
          {isMinLargeMobile && !isMinLargeTablet && <MdOrangeLogo />}
          {isMinLargeTablet && <LgOrangeLogo />}
        </>
      )}
    </StyledLink>
  );
};

export default memo(Logo);
